import { render, staticRenderFns } from "./userGroupMenu.vue?vue&type=template&id=3738eab8&scoped=true"
import script from "./userGroupMenu.vue?vue&type=script&lang=js"
export * from "./userGroupMenu.vue?vue&type=script&lang=js"
import style0 from "./userGroupMenu.vue?vue&type=style&index=0&id=3738eab8&prod&scoped=true&lang=scss"
import style1 from "./userGroupMenu.vue?vue&type=style&index=1&id=3738eab8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3738eab8",
  null
  
)

export default component.exports